import { Input } from '../ui/Input';
import { FormSection } from '../ui/FormSection';
import type { OnboardingFormData } from './types';

interface OnboardingStepPreferencesProps {
  formData: OnboardingFormData;
  disabled: boolean;
  onChange: (field: keyof OnboardingFormData, value: string) => void;
}

/** Step 2 — optional taste preferences. */
export const OnboardingStepPreferences = ({
  formData,
  disabled,
  onChange,
}: OnboardingStepPreferencesProps) => (
  <FormSection
    title="Preferences"
    description="These preferences are optional and can be updated later in your profile settings."
    divider={false}
    className="mt-0"
  >
    <Input
      label="Wine Preferences (optional)"
      type="text"
      value={formData.winePreferencesText}
      onChange={(e) => onChange('winePreferencesText', e.target.value)}
      placeholder="e.g., Cabernet Sauvignon, Chardonnay, Pinot Noir"
      fullWidth
      disabled={disabled}
    />

    <Input
      label="Preferred Wine Region (optional)"
      type="text"
      value={formData.regionPreference}
      onChange={(e) => onChange('regionPreference', e.target.value)}
      placeholder="e.g., Napa Valley, Bordeaux, Tuscany"
      helperText="This will be used for default search location and recommendations"
      fullWidth
      disabled={disabled}
    />

    <Input
      label="Venue Preferences (optional)"
      type="text"
      value={formData.venuePreferencesText}
      onChange={(e) => onChange('venuePreferencesText', e.target.value)}
      placeholder="e.g., Family-friendly, Pet-friendly, Outdoor seating"
      fullWidth
      disabled={disabled}
    />
  </FormSection>
);
